<template>
  <div
    class="charts-container"
    :class="className"
    ref="charts_container"
  >
    
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick
} from 'vue';
import { isNull, dayjs, message, debounce } from '@/utils/js/initVariable';
import * as echarts from 'echarts';
// props
const props = defineProps({
  className: { type: String, },
});
// emit
const emit = defineEmits([
  'chartInit',
]);
const charts_container = ref();
let myChart;
const chartInit = ()=>{
  myChart = echarts.init(charts_container.value);
  emit('chartInit', myChart);
  if(!resizeHandler){
    resizeHandler = debounce(() =>{
      resize();
    }, 0.1 * 1000);
  }
  window.addEventListener('resize', resizeHandler);
  sidebarElm = document.querySelector('.sidebar-container');
  sidebarElm && sidebarElm.addEventListener('transitionend', sidebarHandler)
};

const resize = ()=>{
  myChart && myChart.resize();
}
let resizeHandler,
    sidebarElm,
    sidebarHandler = (e)=>{
      if(e.propertyName == 'width' && resizeHandler){
        resizeHandler();
      }
    };

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  nextTick(()=>{
    chartInit();
  })
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{
  window.removeEventListener('resize', resizeHandler);
  sidebarElm && sidebarElm.removeEventListener('transitionend', sidebarHandler);
});
</script>

<style lang='less'>

</style>

<style lang='less' scoped>
.charts-container{
  height: 100%;
  width: 100%;
}
</style>